export const FEATURE_FLAGS: Record<string, string> = {
  APPLE_LOGIN: 'feat__apple_login'
}

export default FEATURE_FLAGS
